<template>
    <div :id="id">
        <!-- /radar area /-->
    </div>
</template>
<script>
import Echarts from "echarts/lib/echarts.js";
import "echarts/lib/chart/radar.js";
import "echarts/lib/component/legend";
import "echarts/lib/component/title";
import "echarts/lib/component/tooltip";

export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    legend: {
      type: Array,
      default: function() {
        return [];
      }
    },
    series: {
      type: Array,
      default: function() {
        return [];
      }
    },
    indicator: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data: function() {
    return {
      id: `radar-${Date.now()}-${Math.random()
        .toString(16)
        .replace(".", "")}`,
      redar: null,
      is_mounted: false,
      labelTips: {},
      tips: null
    };
  },
  created: function() {
    const that = this;
    const timer = function() {
      if (that.is_mounted && that.series.length > 0) {
        that.buildRadar();
      } else {
        setTimeout(timer, 100);
      }
    };
    timer();
  },
  mounted: function() {
    const that = this;
    that.is_mounted = true;
    const doc = document;
    let tips = doc.createElement("div");
    tips.className = "radar-tips";
    tips.id = `${that.id}-tips`;
    doc.body.appendChild(tips);
    that.tips = tips;
  },
  methods: {
    buildRadar: function() {
      let that = this;
      if (!that.radar) {
        that.radar = Echarts.init(document.querySelector(`#${that.id}`));
      }
      let options = {
        title: { text: that.title },
        tooltip: {
          trigger: "item"
        },
        legend: {
          data: that.legend,
          orient: "vertical",
          right: "20px"
        },
        radar: {
          name: {
            textStyle: {
              color: "#000000",
              fontSize: 16,
              fontWeight: "bold"
            }
          },
          indicator: that.indicator,
          triggerEvent: true
        },
        series: that.series
      };
      that.indicator &&
        that.indicator.length > 0 &&
        that.indicator.forEach(ind => {
          that.labelTips[ind.name] = ind.tips;
        });
      that.radar.setOption(options);
      that.radar.on("mouseover", function(param) {
        if (param.targetType === "axisName") {
          // 获取备注
          const tips = that.labelTips[param.name];
          // 存在备注时弹出
          if (tips && tips.length > 0) {
            that.tips.style.left = param.event.event.pageX + "px";
            that.tips.style.top = param.event.event.pageY + 10 + "px";
            that.tips.innerHTML = `<dl>${tips
              .map(t => "<dt>" + t.name + "</dt><dd>" + t.content + "</dd>")
              .join("")}</dl>`;
            that.tips.style.display = "block";
          }
        }
      });
      that.radar.on("mouseout", function(param) {
        if (param.targetType === "axisName") {
          // 隐藏
          that.tips.style.display = "none";
        }
      });
      that.radar.on("click", param => {
        if (param.targetType === "axisName") {
          // 显示
          if (that.tips.style.display === "none") {
            // 获取备注
            const tips = that.labelTips[param.name];
            // 存在备注时弹出
            if (tips && tips.length > 0) {
              // 弹窗定位
              that.tips.style.left = param.event.event.pageX + "px";
              that.tips.style.top = param.event.event.pageY + 10 + "px";
              // 弹窗内容
              that.tips.innerHTML = `<dl>${tips
                .map(t => "<dt>" + t.name + "</dt><dd>" + t.content + "</dd>")
                .join("")}</dl>`;
              // 显示
              that.tips.style.display = "block";
            }
          } else {
            //隐藏
            that.tips.style.display = "none";
          }
        }
      });
    }
  },
  destroyed: function() {
    let that = this;
    if (that.radar) {
      try {
        that.radar.destroy();
      } catch (e) {}
    }
    if (that.tips) {
      try {
        that.tips.remove();
      } catch (e) {}
    }
  }
};
</script>
<style lang="less">
.radar-tips {
  display: none;
  position: absolute;
  padding: 10px 10px 0;
  width: 200px;
  left: 0;
  top: 0;
  color: #fff;
  border: 1px solid #333;
  background-color: rgba(40, 40, 40, 0.7);
  border-radius: 5px;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  z-index: 9999999;
  dl {
    margin: 0;
    padding: 0;
    dt {
      font-weight: 700;
    }
    dd {
      margin: 0;
      padding: 10px 0 10px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// radar.vue?37b0f97c